export const skipFirstRow = (index, value) => {
  return index != 0 ? value : '';
};

export const toMatrix = (cashflow, totals, isSecontHeader) => {
  const totalsRow = [
    'Totals',
    undefined,
    undefined,
    totals.ReductionInLiability,
    totals.InsurerPaidLosses,
    totals.InsurancePremium,
    undefined,
    undefined,
    undefined,
    totals.NetInsuranceCashflow,
    undefined,
    totals.CollateralLosses
  ];

  const cashflowRows = [
    [
      'Period',
      'Payment Date',
      isSecontHeader ? 'Outstanding Limit' : 'Remaining Liability',
      isSecontHeader ? 'Reduction In Limit' : 'Reduction In Liability',
      isSecontHeader ? 'Limit Losses' : 'Insurer Paid Losses',
      isSecontHeader ? 'Premium' : 'Insurance Premium',
      isSecontHeader ? 'Required Collateral' : 'Collateral Trust Account',
      isSecontHeader ? 'Collateral Change' : 'Collateral Account Change',
      isSecontHeader ? 'Collateral Interest' : 'Interest',
      isSecontHeader ? 'Re-Insurance Cashflow' : 'Net Insurance Cashflow',
      isSecontHeader ? 'Ref Pool Balance' : 'Collateral Balance',
      isSecontHeader ? 'Ref Pool Losses' : 'Collateral Losses',
      isSecontHeader ? 'CPR' : 'CPR Rate',
      isSecontHeader ? 'CDR' : 'CDR Rate',
      isSecontHeader ? 'Severity' : 'Loss Severity Rate',
      isSecontHeader ? 'Delinquency' : 'Delinquency Rate'
    ]
  ];

  for (let i = 0; i < cashflow.length; i++) {
    cashflowRows.push([
      cashflow[i].Period,
      cashflow[i].PaymentDate,
      cashflow[i].RemainingLiability,
      cashflow[i].ReductionInLiability,
      cashflow[i].InsurerPaidLosses,
      skipFirstRow(cashflow[i].Period, cashflow[i].InsurancePremium),
      cashflow[i].CollateralTrustAccount,
      cashflow[i].CollateralAccountChange,
      skipFirstRow(cashflow[i].Period, cashflow[i].CollateralAccountInterest),
      cashflow[i].NetInsuranceCashflow,
      cashflow[i].CollateralBalance,
      cashflow[i].CollateralLosses,
      skipFirstRow(cashflow[i].Period, cashflow[i].CprRate),
      skipFirstRow(cashflow[i].Period, cashflow[i].CdrRate),
      skipFirstRow(cashflow[i].Period, cashflow[i].LossSeverityRate),
      skipFirstRow(cashflow[i].Period, cashflow[i].DelinquencyRate)
    ]);
  }

  const result = [totalsRow].concat(cashflowRows);

  return result;
};
